<template>
  <div>
    <v-container>
      <v-row>
        <v-col
          cols="12"
          sm="10"
          md="10"
          lg="10"
          class="d-flex flex-wrap"
        >
          <v-row
            v-if="exibirChips"
          >
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-tooltip
                v-for="chip in appliedFilters"
                :key="chip.label"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    v-bind="attrs"
                    class="ma-1"
                    color="#e8f1ff"
                    text-color="#2863af"
                    small
                    :close="!['mes', 'ano'].includes(chip.key)"
                    v-on="on"
                    @click:close="removeFilter(chip.key)"
                  >
                    {{ chip.label }}
                  </v-chip>
                </template>
                <span>{{ getTooltipValue(chip) }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="2"
          lg="2"
          class="d-flex justify-end"
        >
          <v-btn
            v-if="exibirChips"
            text
            :color="corPrimaria"
            @click="updateDate()"
          >
            <v-icon>
              mdi-reload-alert
            </v-icon>
            Consultar
          </v-btn>
          <v-btn
            text
            style="color: #2863af;"
            @click="toggleDrawer"
          >
            <v-icon>{{ drawer ? 'mdi-filter-minus' : 'mdi-filter-plus' }}</v-icon>
            {{ drawer ? 'Fechar filtros' : 'Filtros' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-navigation-drawer
      v-model="drawer"
      right
      temporary
      width="600"
      fixed
      attach="body"
      class="pa-4 elevation-10 drawerFiltros"
      style="z-index: 3000;"
    >
      <v-container>
        <v-row>
          <v-row>
            <v-col class="d-flex justify-end">
              <v-btn
                text
                style="color: #2863af;"
                @click="toggleDrawer"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-col cols="12">
            <transition name="filters">
              <v-row>
                <v-col
                  v-if="vendedores"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="vendedorSelect"
                    :items="vendedor"
                    item-value="id"
                    item-text="vendedor"
                    label="Vendedores"
                    return-object
                    @change="handleSelectVendedor"
                  />
                </v-col>
                <v-col
                  v-if="redes"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="redeSelect"
                    :items="rede"
                    item-value="id"
                    item-text="rede"
                    label="Todas Redes"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.rede }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.rede }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ redeSelect.length - 2 }} outros)
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="supervisores"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="supervisorSelect"
                    :items="supervisor"
                    item-value="id"
                    item-text="supervisor"
                    label="Todos Supervisores"
                    multiple
                    return-object
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                        <span>{{ item.supervisor }}, </span>
                      </v-chip>
                      <v-chip v-if="index === 1">
                        <span>{{ item.supervisor }}, </span>
                      </v-chip>
                      <span
                        v-if="index === 2"
                        class="grey--text text-caption"
                      >
                        (+{{ supervisorSelect.length - 2 }} outros)
                      </span>
                    </template>
                  </v-select>
                </v-col>
                <v-col
                  v-if="meses"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="mesSelect"
                    :items="mes"
                    item-value="texto"
                    item-text="texto"
                    label="Mês"
                    return-object
                    @change="handleSelectMes"
                  />
                </v-col>
                <v-col
                  v-if="anos"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-select
                    v-model="anoSelect"
                    :items="anosFaturamento"
                    item-value="id"
                    item-text="nomeExibicao"
                    label="Ano"
                    return-object
                    @change="handleSelectAno"
                  />
                </v-col>
                <v-col
                  v-if="btn1"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-btn
                    id="btnRefazer"
                    class="col-12 lg-12 text-h4"
                    small
                    :color="corPrimaria"
                    dark
                    @click="updateDate()"
                  >
                    <v-icon>
                      mdi-reload-alert
                    </v-icon>
                    Refazer
                  </v-btn>
                </v-col>
                <v-col
                  v-if="btn2"
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                >
                  <v-btn
                    id="btnRefazer"
                    class="col-12 lg-12 text-h4"
                    small
                    :color="corPrimaria"
                    dark
                    @click="updateDateVendedor()"
                  >
                    <v-icon>
                      mdi-reload-alert
                    </v-icon>
                    Refazer
                  </v-btn>
                </v-col>
              </v-row>
            </transition>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>
<script>
  import eventEmit from './EventoEmit'

  export default {
    name: 'DashboardCoreFiltroDatas',
    emits: ['updateDadosFiltros'],
    components: {
      DashboardCoreSnackbar: () => import('./Snackbar'),
    },
    props: {
      meses: {
        type: Boolean,
        default: false,
      },
      anos: {
        type: Boolean,
        default: false,
      },
      redes: {
        type: Boolean,
        default: false,
      },
      vendedores: {
        type: Boolean,
        default: false,
      },
      supervisores: {
        type: Boolean,
        default: false,
      },
      btn1: {
        type: Boolean,
        default: false,
      },
      btn2: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      mes: [
        { texto: 'Janeiro', valor: '01' }, { texto: 'Fevereiro', valor: '02' }, { texto: 'Março', valor: '03' },
        { texto: 'Abril', valor: '04' }, { texto: 'Maio', valor: '05' }, { texto: 'Junho', valor: '06' },
        { texto: 'Julho', valor: '07' }, { texto: 'Agosto', valor: '08' }, { texto: 'Setembro', valor: '09' },
        { texto: 'Outubro', valor: '10' }, { texto: 'Novembro', valor: '11' }, { texto: 'Dezembro', valor: '12' },
      ],
      mesSelect: [],
      selectMes: [],
      anosFaturamento: [],
      anoSelect: [],
      selectAno: [],
      rede: [],
      redeSelect: [],
      vendedor: [],
      vendedorSelect: [],
      selectVendedor: [],
      supervisor: [],
      supervisorSelect: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      corPrimaria: localStorage.corPrimaria,
      icone: 'mdi-chevron-down',
      textFiltro: 'Exibir Filtro',
      expandFiltro: (window.innerWidth <= 681) ? null : true,
      drawer: false,
      exibirChips: false,
      montardadosMes: true,
      montardadosAnos: true,
    }),

    computed: {
      filtros () {
        this.montarDadosFiltros(this.$store.state.filtros)

        return this.$store.state.filtros
      },

      appliedFilters () {
        const chips = []
        var i = 0

        // Datas
        if (this.mesSelect) {
          chips.push({
            key: 'mes',
            label: `Mês: ${this.mesSelect.texto}`,
          })
        }

        if (this.anoSelect) {
          chips.push({
            key: 'ano',
            label: `Ano: ${this.anoSelect}`,
          })
        }

        if (this.selectVendedores?.length) {
          const vendedorAux = []

          for (i in this.selectVendedores) {
            vendedorAux.push(this.selectVendedores[i].vendedor + ' - ' + this.selectVendedores[i].nomeBd)
          }

          chips.push({
            key: 'vendedores',
            label: `Vendedor(es) (${this.selectVendedores.length})`,
            value: vendedorAux,
          })
        }

        if (this.redeSelect?.length) {
          const redeAux = []

          for (i in this.redeSelect) {
            redeAux.push(this.redeSelect[i].rede)
          }

          chips.push({
            key: 'redes',
            label: `Rede(s) (${this.redeSelect.length})`,
            value: redeAux,
          })
        }

        if (this.supervisorSelect?.length) {
          const supervisorAux = []

          for (i in this.supervisorSelect) {
            supervisorAux.push(this.supervisorSelect[i].supervisor)
          }

          chips.push({
            key: 'supervisores',
            label: `Supervisor(es) (${this.supervisorSelect.length})`,
            value: supervisorAux,
          })
        }

        return chips
      },
    },

    watch: {
      'filtros.empresas': {
        immediate: true,
        handler (empresa) {
          if (empresa && empresa.length === 1) {
            this.select = [...empresa]
          }
        },
      },

      meses: function (val) {
        this.meses = val
      },

      anos: function (val) {
        this.anos = val
      },

      vendedores: function (val) {
        this.vendedores = val
      },

      redes: function (val) {
        this.redes = val
      },

      supervisores: function (val) {
        this.supervisores = val
      },

      btn1: function (val) {
        this.btn1 = val
      },

      btn2: function (val) {
        this.btn2 = val
      },
    },

    created () {
      eventEmit.$on('enable-filtros-print', this.handleFiltros)
    },

    beforeDestroy () {
      eventEmit.$off('enable-filtros-print', this.handleFiltros)
    },

    mounted () {
      const isMobile = (window.innerWidth <= 768) ? null : true

      if (isMobile) {
        if (this.icone === 'mdi-chevron-up') {
          this.expandFiltro = false
          this.icone = 'mdi-chevron-down'
          this.textFiltro = 'Exibir Filtro'
        } else {
          this.textFiltro = 'Recolher Filtro'
          this.expandFiltro = true
          this.icone = 'mdi-chevron-up'
        }
      }

      this.$store.dispatch('carregarFiltros')

      this.exibirChips = true
    },

    methods: {
      montarDadosFiltros (dados) {
        this.anosFaturamento = dados.anosFaturamento
        this.rede = dados.rede
        this.vendedor = dados.vendedor
        this.supervisor = dados.supervisor

        var i = 0

        if (this.montardadosAnos) {
          for (i in this.anosFaturamento) {
            if (this.anosFaturamento[i] === new Date().getFullYear()) {
              this.anoSelect = this.anosFaturamento[i]
              this.handleSelectAno()
            }
          }

          this.montardadosAnos = false
        }

        i = 0

        if (this.montardadosMes) {
          for (i in this.mes) {
            if (this.mes[i].valor === (new Date().getMonth() + 1).toString().padStart(2, '0')) {
              this.mesSelect = this.mes[i]
              this.handleSelectMes()
            }
          }

          this.montardadosMes = false
        }
      },

      toggleDrawer () {
        this.drawer = !this.drawer
      },

      removeFilter (key) {
        switch (key) {
          case 'vendedores':
            this.selectVendedores = []
            break
          case 'redes':
            this.redeSelect = []
            break
          case 'supervisores':
            this.supervisorSelect = []
            break
          case 'mes':
            break
          case 'ano':
            break
        }
      },

      getTooltipValue (chip) {
        if (Array.isArray(chip.value)) {
          return chip.value.join(', ')
        }

        return chip.label
      },

      handleFiltros (mes, ano, vendedores) {
        this.selectMes = mes

        this.selectAno = ano

        this.selectVendedor = vendedores
      },

      handleSelectMes () {
        this.selectMes = []

        this.selectMes = [this.mesSelect]
      },

      handleSelectAno () {
        this.selectAno = []

        this.selectAno = [this.anoSelect]
      },

      handleSelectVendedor () {
        this.selectVendedor = []

        this.selectVendedor = [this.vendedorSelect]
      },

      updateDateVendedor () {
        if (this.selectVendedor.length > 0 && this.selectMes.length > 0 && this.selectAno.length > 0) {
          eventEmit.$emit('update-dados-filtros', this.selectVendedor, this.redeSelect, this.selectMes, this.selectAno, this.supervisorSelect)
        } else {
          alert('Selecionar vendedor, mês e ano, para exibir os dados.')
        }
      },

      updateDate () {
        if (this.selectMes.length > 0 && this.selectAno.length > 0) {
          eventEmit.$emit('update-dados-filtros', this.selectVendedor, this.redeSelect, this.selectMes, this.selectAno, this.supervisorSelect)
        } else {
          alert('Selecionar mês e ano, para exibir os dados.')
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },

  }
</script>

<style scoped>
  .drawerFiltros {
    top: 65px !important;
    height: auto !important;
    max-height: calc(100vh - 65px);
    overflow-y: auto;
    box-shadow: -2px 0 12px rgba(0,0,0,0.25);
  }

  .filters-enter-active {
    animation: enter .5s cubic-bezier(.34,1.56,.64,1);
  }

  .filters-leave-active {
    animation: leave .5s ease;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    .filterMobile{
      display: block
    }

    .filterWeb{
      display: none
    }
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }
</style>

<style lang="sass">
  #btnRefazer
    margin: 1.5rem auto

  .filterMobile
    display: none

  .filterWeb
    display: block

</style>
